import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('creation_pulling_of_templatename'),
    submitterListDescriptionEmpty: defineMessage('add_at_least_one_user_a_approval_in_approvalmax'),
    submitterListDescriptionNonEmpty: defineMessage('add_users_authorised_to_approval_in_approvalmax'),
    createInAmBubbleText: defineMessage('create_in_approvalmax'),
    emailExternalSubmitterTitle: defineMessage('approvalmax_will_create_the_email_address_below'),
    emailExternaSubmitterDescriptionNonEmpty: defineMessage('pluraltemplatename_will_ubmit_them_for_approval'),
    emailExternalSubmitterDescriptionEmpty: defineMessage('enter_the_user_who_will_anycom_can_also_be_used_1'),
};
